module.exports = __webpack_public_path__ + "img/error.4bc45293.gif";